// extracted by mini-css-extract-plugin
export default {"wrap":"LoadingSpinner_wrap__WlTAs","message":"LoadingSpinner_message__d2v0U"};